import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ToastrModule } from 'ngx-toastr';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { AppInterceptor, TokenService, SharedService, UploadService } from './services';
import { AuthGuard, AccessAuthGuard } from './guards';
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';
import { ConfirmationComponent, ThankYouComponent } from './components';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ToastrModule.forRoot(),
    ReactiveFormsModule,
    NgbModule.forRoot(),
  ],
  declarations: [PageNotFoundComponent, ConfirmationComponent, ThankYouComponent],
  exports: [FormsModule, ReactiveFormsModule, NgbModule],
  entryComponents: [ConfirmationComponent, ThankYouComponent],
  providers: [UploadService]
})
export class SharedModule {
  public static forRoot(): ModuleWithProviders {
    return {
      ngModule: SharedModule,
      providers: [AppInterceptor, SharedService, UploadService, AuthGuard, AccessAuthGuard, TokenService,
        { provide: HTTP_INTERCEPTORS, useClass: AppInterceptor, multi: true }
      ]
    };
  }

}

export { PageNotFoundComponent, ConfirmationComponent, ThankYouComponent } from './components';
export { Constants } from './constants';
export { SharedService, UploadService } from './services';
export { AuthGuard, AccessAuthGuard } from './guards';
